import PropTypes from "prop-types"
import React, { useState } from "react"

// #78FF63

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Spinner,
} from "reactstrap"

// Formik validation
import { useFormik } from "formik"
import * as Yup from "yup"

// import images
import profile from "assets/images/changePass.svg"

import { faEye } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { withTranslation } from "react-i18next"
import { BgAnimado } from "./Components/BgAnimado/BgAnimado"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { clientCapitalized } from "assets"
import { changePass } from "services/auth/calls"
import jwt from "jsonwebtoken"
import { authProtectedRoutes } from "routes"
import toast from "components/Toast/Toast"

const eye = <FontAwesomeIcon icon={faEye} />

const PasswordChange = props => {
  const { t, loading } = props
  //meta title
  document.title = `Nova Senha | Sensetek ${clientCapitalized}`

  let history = useHistory()

  const [oldPasswordShown, setOldPasswordShown] = useState(false)
  const [newPasswordShown, setNewPasswordShown] = useState(false)
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false)

  const toggleOldPassword = () => {
    setOldPasswordShown(!oldPasswordShown)
  }
  const toggleNewPassword = () => {
    setNewPasswordShown(!newPasswordShown)
  }
  const toggleConfirmPassword = () => {
    setConfirmPasswordShown(!confirmPasswordShown)
  }

  const [isLoading, setIsLoading] = useState(false)

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      oldPass: "",
      newPass: "",
      confirmPass: "",
    },
    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/
    validationSchema: Yup.object({
      oldPass: Yup.string().required(t("SenhaAntigaValidacao")),
      newPass: Yup.string()
        .required(t("SenhaNovaValidacao"))
        .min(8, t("SenhaMin8Validacao"))
        .matches(/^(?=.*[a-z])/, t("SenhaMin1MinusculoValidacao"))
        .matches(/^(?=.*[A-Z])/, t("SenhaMin1MaiusculoValidacao"))
        .matches(/^(?=.*[0-9])/, t("SenhaMin1NumeroValidacao"))
        .matches(/^(?=.*[!@#\$%\^&\*])/, t("SenhaMin1EspecialValidacao")),
      confirmPass: Yup.string().oneOf(
        [Yup.ref("newPass"), null],
        t("SenhaConfirmaValidacao")
      ),
    }),
    onSubmit: async ({ oldPass, newPass }) => {
      try {
        setIsLoading(true)
        const {
          payload: { accessToken },
        } = await changePass({
          currentPassword: oldPass,
          password: newPass,
        })
        localStorage.setItem("token", accessToken)
        const roles = jwt.decode(accessToken)?.roles
        if (roles?.length === 0) {
          history.push("/no-profiles")
        } else {
          try {
            const paths = authProtectedRoutes.filter(apr =>
              apr?.requiredRoles?.includes(roles[0]) ? true : false
            )
            history.push(paths[0].path)
          } catch (error) {
            console.error(error)
          }
        }
      } catch (error) {
        console.error(error)
        toast("warning", error.message)
      } finally {
        setIsLoading(false)
      }
    },
  })

  return (
    <React.Fragment>
      <div
        className="account-pages my-5 pt-sm-5"
        style={{
          position: "absolute",
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
          margin: "auto",
          zIndex: "100",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {t("Nova Senha Header 1")}
                        </h5>
                        <p>{`${t(
                          "Nova Senha Header 2"
                        )} ${clientCapitalized}`}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  {/* <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4 ms-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            height="60"
                            className="ms-4 mt-4"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row>
                        <Col>
                          <Label className="form-label">
                            {t("Senha Antiga")}
                          </Label>
                          <InputGroup>
                            <Input
                              name="oldPass"
                              value={validation.values.oldPass || ""}
                              type={oldPasswordShown ? "text" : "password"}
                              placeholder={t("Senha Antiga")}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.oldPass &&
                                validation.errors.oldPass
                                  ? true
                                  : false
                              }
                            />
                            <InputGroupText>
                              <i onClick={toggleOldPassword}>{eye}</i>
                            </InputGroupText>
                            {validation.touched.oldPass &&
                            validation.errors.oldPass ? (
                              <FormFeedback type="invalid">
                                {validation.errors.oldPass}
                              </FormFeedback>
                            ) : null}
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="my-2">
                        <Col>
                          <span className="text-muted">
                            (A nova senha deve contar no mínimo 8 caractéres, 1
                            maiúsculo, 1 minúsculo, 1 número e 1 caracter
                            especial)
                          </span>
                        </Col>
                      </Row>
                      <div>
                        <Label className="form-label">{t("Senha Nova")}</Label>
                        <InputGroup>
                          <Input
                            name="newPass"
                            value={validation.values.newPass || ""}
                            type={newPasswordShown ? "text" : "password"}
                            placeholder={t("Senha Nova")}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.newPass &&
                              validation.errors.newPass
                                ? true
                                : false
                            }
                          />
                          <InputGroupText>
                            <i onClick={toggleNewPassword}>{eye}</i>
                          </InputGroupText>
                          {validation.touched.newPass &&
                          validation.errors.newPass ? (
                            <FormFeedback type="invalid">
                              {validation.errors.newPass}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </div>

                      <br></br>

                      <div>
                        <Label className="form-label">
                          {t("Senha Nova Confirmação")}
                        </Label>
                        <InputGroup>
                          <Input
                            name="confirmPass"
                            value={validation.values.confirmPass || ""}
                            type={confirmPasswordShown ? "text" : "password"}
                            placeholder={t("Senha Nova Confirmação")}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.confirmPass &&
                              validation.errors.confirmPass
                                ? true
                                : false
                            }
                          />
                          <InputGroupText>
                            <i onClick={toggleConfirmPassword}>{eye}</i>
                          </InputGroupText>
                          {validation.touched.confirmPass &&
                          validation.errors.confirmPass ? (
                            <FormFeedback type="invalid">
                              {validation.errors.confirmPass}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {loading && (
                            <div
                              className="mt-3"
                              style={{ textAlign: "center" }}
                            >
                              <Spinner className="ms-2" color="primary" />
                            </div>
                          )}
                          {!loading && t("Atualizar")}
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>{t("DireitosReservados")}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <BgAnimado />
    </React.Fragment>
  )
}

PasswordChange.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(PasswordChange)
